import { connect } from 'react-redux';
import HeaderText from 'header/components/title';
import { withRouter } from 'react-router';

export function mapStateToProps() {
  return {
    title: "Sorry, this person is not active..."
  };
}

export default withRouter(connect(mapStateToProps)(HeaderText));
